import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { events } from '#utilities/js/lightboxes/lightbox.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import { cleanup } from '#utilities/js/media/stream.js'
import { videoOnly } from '#utilities/js/media/constraints.js'
import defaults from '@mailobj-browser/front/js/selectors/defaults.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const { open } = events

const onOpen = object(listener, {
  type: open,
  passive,
  task: async (
    opener,
    { detail: modal }
  ) => {
    const { window } = defaults

    await removed(modal)
    cleanup(window, videoOnly)
  }
})

export default async opener => {
  onOpen.listen(opener)
}